export default __webpack_public_path__ + "static/media/bacolod.d9d2282e.webp";